import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { BG_PAGE, BRAND, TEXT_INK, TEXT_DARK, BORDER, CONTAINER } from "../tokens";

interface QA { q: string; a: string; }

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);
  const qs: QA[] = [
    { q: "What makes Novala different from generic payroll apps?", a: "Most payroll apps make you chase, collect, and key in timesheets every period. Novala flips it: your team clocks in and out, the worked hours fill themselves onto the timesheet, and Novala reminds anyone who leaves while still clocked in to clock out. You review and approve, then the hours flow straight into the pay run." },
    { q: "How does the clock-out reminder work?", a: "Location is used only for the reminder, with your team's consent, not to track them through the day. If a phone leaves the work location while still clocked in, Novala sends a clock-out reminder. If a clock out gets missed, you correct it on the timesheet before pay runs." },
    { q: "How do I invite my team to start using it?", a: "From the Add employee flow, choose Employee self setup and send one invite. The employee gets a link to a secure, tokened page where they fill in their banking, tax forms, contact info, and emergency contact themselves. Their status on your Employees page updates as they complete it." },
    { q: "What can my team update themselves?", a: "Personal details and address, direct deposit banking, tax forms (such as TD1 or W-4), and emergency contact. Sensitive employer-controlled fields stay with you." },
    { q: "Is the app free for my team?", a: "Yes. Pay stubs, year end tax documents, time tracking, time off, and notifications are free for every employee on your account. There is no per-seat charge for them." },
    { q: "Can my team still see their pay if I pause payroll?", a: "Yes. Past pay stubs and year end tax documents stay available to your team in the app, even if you pause or change plans, so they always have what they need for the bank, the landlord, and tax time." },
  ];
  return (
    <section style={{ background: BG_PAGE, padding: "100px 0" }}>
      <div style={{ ...CONTAINER, maxWidth: 880 }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h2 style={{ fontSize: "clamp(32px, 4vw, 42px)", fontWeight: 800, color: TEXT_INK, letterSpacing: "-0.02em", margin: 0 }}>Frequently asked questions</h2>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {qs.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} style={{ border: "0.5px solid " + BORDER, borderRadius: 12, background: "#FFFFFF", overflow: "hidden" }}>
                <div onClick={() => setOpen(isOpen ? -1 : i)} style={{ padding: "20px 22px", display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}>
                  <span style={{ fontSize: 15.5, fontWeight: 700, color: TEXT_INK, letterSpacing: "-0.005em" }}>{it.q}</span>
                  <span style={{ color: BRAND, transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
                    <ChevronDown size={18} />
                  </span>
                </div>
                {isOpen && (
                  <div style={{ padding: "0 22px 22px", fontSize: 14.5, color: TEXT_DARK, lineHeight: 1.65 }}>
                    {it.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}